import {
  LIST_ERP_VERSAO_QUERYS_INIT,
  LIST_ERP_VERSAO_QUERYS_SUCCESS,
  LIST_ALL_QUERYS_INIT,
  LIST_ALL_QUERYS_SUCCESS,
  CREATE_QUERY_INIT,
  CREATE_QUERY_SUCCESS,
  UPDATE_QUERY_INIT,
  UPDATE_QUERY_SUCCESS,
  DELETE_QUERY_INIT,
  DELETE_QUERY_SUCCESS,
  QUERYS_ERROR_MSG,
  CLEAR_FLAGS_QUERYS,
  CLEAR_QUERYS
} from '../actionTypes';

export const listQuerysInit = (data: any) => ({
  type: LIST_ERP_VERSAO_QUERYS_INIT,
  payload: data
});

export const listQuerysSuccess = (data: any) => ({
  type: LIST_ERP_VERSAO_QUERYS_SUCCESS,
  payload: data
});

export const listAllQuerysInit = (data?: any) => ({
  type: LIST_ALL_QUERYS_INIT,
  payload: data
});

export const listAllQuerysSuccess = (data: any) => ({
  type: LIST_ALL_QUERYS_SUCCESS,
  payload: data
});

export const createQueryInit = (data: any) => ({
  type: CREATE_QUERY_INIT,
  payload: data
});

export const createQuerySuccess = (data: any) => ({
  type: CREATE_QUERY_SUCCESS,
  payload: data
});

export const updateQueryInit = (data: any) => ({
  type: UPDATE_QUERY_INIT,
  payload: data
});

export const updateQuerySuccess = (data: any) => ({
  type: UPDATE_QUERY_SUCCESS,
  payload: data
});

export const deleteQueryInit = (data: any) => ({
  type: DELETE_QUERY_INIT,
  payload: data
});

export const deleteQuerySuccess = (data: any) => ({
  type: DELETE_QUERY_SUCCESS,
  payload: data
});

export const requestErrorQuerys = (msg: string) => ({
  type: QUERYS_ERROR_MSG,
  payload: msg
});

export const clearFlagsQuerys = () => ({
  type: CLEAR_FLAGS_QUERYS
});

export const clearQuerys = () => ({
  type: CLEAR_QUERYS
});
